import { lazy, Suspense } from 'react';

import { ModalWrapper } from '@braskai/ui-kit';

import { useDebugMenuStore } from '../../model/useDebugMenuStore';

const DebugMenuContent = lazy(() =>
  import('./DebugMenuContent').then((module) => ({ default: module.DebugMenuContent })),
);

export const DebugMenu = () => (
  <ModalWrapper hook={useDebugMenuStore}>
    <Suspense fallback={null}>
      <DebugMenuContent />
    </Suspense>
  </ModalWrapper>
);
